import { BaseApiUrl } from '../../../configVariables';
import { HealthInfo } from '../../../model/HealthInfo';
import apiClient from '../../../utils/apiClient';
import { extractBlobData } from '../../../utils/apiClient.utils';

const baseUrl = BaseApiUrl + '/healthInfo';

export const fetchHealthInfo = async () => {
    return apiClient.get<HealthInfo>(baseUrl);
};

export const downloadFailureReport = async () => {
    const resp = await apiClient.getBlob(baseUrl + '/report');

    return extractBlobData(resp, 'failures.xlsx');
};
